import { Auth, Locale } from 'services'
import _ from 'lodash'
import { SetupLocales } from 'i18n'
import VueRouter from 'vue-router'
import Vue from 'vue'

Vue.use(VueRouter)

import routes from './routes'

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  let redirect = null
  const token = Auth.getToken()
  const authenticated = token && Auth.checkToken(token)

  if (authenticated) {
    Auth.setAuthorizationHeader(token)
  } else {
    Auth.setAuthorizationHeader('')
    if (to.name !== 'login') redirect = { name: 'login', params: { intendedRoute: to } }
  }

  if (authenticated && _.isEmpty(Locale.getCachedLocales())) {
    SetupLocales()
  }
  return redirect ? next(redirect) : next()
})

export default router
